module.exports = __webpack_public_path__ + "img/portfolio_1.8a8d7e5d.jpg";